import { FC, memo } from 'react';

import { useNotificationContext } from 'application/providers/NotificationProvider';

import { usePointsGroupUpdateMutation } from 'domain/api/graphql/generated';

import Button, { ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';
import ModalScreen from '@zvuk-b2b/react-uikit/ui/ModalScreen';
import Input, { InputType } from '@zvuk-b2b/react-uikit/ui/Input';

import { useDispatch, useSelector } from 'react-redux';
import { TEXTS } from './texts';

import styles from './index.module.scss';
import { setStep, setTitle } from '../../slices/createPointsGroup/slice';
import { selectTitle } from '../../slices/createPointsGroup/selectors';
import { CREATE_POINTS_GROUP_STEPS } from '../../slices/createPointsGroup/consts';

const MAX_TITLE_LENGTH = 128;

interface ISelectPointsGroupTitleProps {
  close: () => void;
}

export const SelectPointsGroupTitle: FC<ISelectPointsGroupTitleProps> = memo(({ close }) => {
  const dispatch = useDispatch();

  const onSetTitle = (value: string) => {
    if (value.length <= MAX_TITLE_LENGTH) {
      dispatch(setTitle(value));
    }
  };

  const title = useSelector(selectTitle);

  const onSave = async () => {
    dispatch(setStep(CREATE_POINTS_GROUP_STEPS.DEVICES));
  };

  return (
    <ModalScreen
      title={TEXTS.TITLE}
      titlePlacement="left"
      onClose={close}
      className={styles.description}
      actionButtons={[
        <Button
          key="button_rename_points_group_modal"
          elementId="button_rename_points_group_modal"
          type={ButtonType.PRIMARY}
          isDisabled={!title}
          onClick={onSave}>
          {TEXTS.SAVE_BUTTON_TEXT}
        </Button>,
        <Button
          key="button_bind_video_stream_modal_close"
          elementId="button_bind_video_stream_modal_close"
          type={ButtonType.SECONDARY}
          onClick={close}>
          {TEXTS.CANCEL}
        </Button>,
      ]}>
      <Input
        label={TEXTS.LABEL}
        elementId="button_rename_points_group_input"
        type={InputType.TEXT}
        containerClassName={styles.input}
        value={title}
        maxLength={MAX_TITLE_LENGTH}
        placeholder={TEXTS.INPUT_PLACEHOLDER}
        onChange={onSetTitle}
      />
    </ModalScreen>
  );
});
